if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.initMediaArrows();
      if (this.hasAttribute('data-noble-mobile-media-test')) {
        this.elements.viewer.addEventListener('slideChanged', (event) => this.prepareSelectedImage(event.detail.currentElement));
      }
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }


    initMediaArrows() {
      if (!this.elements.viewer || this.elements.viewer.querySelector('.noble-media-arrows')) return;
      const controls = document.createElement('div');
      controls.className = 'noble-media-arrows';
      controls.hidden = true;
      ['previous', 'next'].forEach((direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'noble-media-arrow noble-media-arrow--' + direction;
        button.setAttribute('aria-label', direction === 'previous' ? 'Previous product media' : 'Next product media');
        button.setAttribute('aria-controls', this.elements.viewer.id);
        button.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="' + (direction === 'previous' ? 'M14 6l-6 6 6 6' : 'M10 6l6 6-6 6') + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        button.addEventListener('click', () => this.navigateMedia(direction));
        controls.appendChild(button);
      });
      this.elements.viewer.appendChild(controls);
      this.mediaArrows = controls;
      this.elements.viewer.addEventListener('slideChanged', () => this.updateMediaArrows());
      this.mql.addEventListener('change', () => this.updateMediaArrows());
      this.mediaArrowObserver = new MutationObserver(() => this.updateMediaArrows());
      this.mediaArrowObserver.observe(this.elements.viewer.querySelector('.product__media-list'), {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
      this.updateMediaArrows();
    }

    arrowMediaItems() {
      return Array.from(this.elements.viewer.querySelectorAll('.product__media-list > [data-media-id]')).filter((item) => {
        if (item.hasAttribute('data-gang-option') && !item.classList.contains('gang__active')) return false;
        const thumbnail = this.elements.thumbnails && this.elements.thumbnails.querySelector('[data-target="' + item.dataset.mediaId + '"]');
        if (thumbnail) return getComputedStyle(thumbnail).display !== 'none';
        return !item.classList.contains('product__media-item--variant') || item === item.parentElement.firstElementChild || item.classList.contains('is-active');
      });
    }

    arrowMediaIndex(items) {
      if (!this.mql.matches && this.elements.viewer.slider) {
        const slider = this.elements.viewer.slider;
        return items.reduce((nearest, item, index) =>
          Math.abs(item.offsetLeft - slider.scrollLeft) < Math.abs(items[nearest].offsetLeft - slider.scrollLeft) ? index : nearest, 0);
      }
      const active = items.findIndex((item) => item.classList.contains('is-active'));
      return Math.max(0, active);
    }

    updateMediaArrows() {
      if (!this.mediaArrows) return;
      const items = this.arrowMediaItems();
      this.mediaArrows.hidden = items.length < 2;
      const index = this.arrowMediaIndex(items);
      this.mediaArrows.querySelector('.noble-media-arrow--previous').disabled = index === 0;
      this.mediaArrows.querySelector('.noble-media-arrow--next').disabled = index >= items.length - 1;
    }

    navigateMedia(direction) {
      const items = this.arrowMediaItems();
      const index = this.arrowMediaIndex(items) + (direction === 'next' ? 1 : -1);
      if (!items[index]) return;
      this.setActiveMedia(items[index].dataset.mediaId, false, false);
      if (!this.mql.matches && !this.elements.thumbnails && this.elements.viewer.slider) {
        this.elements.viewer.slider.scrollTo({ left: items[index].offsetLeft });
      }
      this.updateMediaArrows();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    prepareSelectedImage(activeMedia) {
      if (!this.hasAttribute('data-noble-mobile-media-test') || !activeMedia) return;
      this.elements.viewer.querySelectorAll('.product__media-list img').forEach((image) => {
        const selected = image.closest('.product__media-item') === activeMedia;
        image.fetchPriority = selected ? 'high' : 'auto';
        image.loading = selected ? 'eager' : 'lazy';
      });
      activeMedia.querySelectorAll('use-animate').forEach((wrapper) => {
        wrapper.removeAttribute('data-animate');
        wrapper.classList.remove('loading');
      });
      activeMedia.querySelectorAll('.image-animate').forEach((element) => element.classList.remove('image-animate'));
      activeMedia.querySelectorAll('img').forEach((image) => image.classList.add('loaded'));
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      this.prepareSelectedImage(activeMedia);
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);
      this.updateMediaArrows();

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}


